import React, { useEffect, useState, useRef } from "react";
import Header from '../../components/header/Header';
import Sidebar from '../../components/sidebar/Sidebar';
import { useNavigate } from "react-router-dom";
import { getProfile, getCountryList, editProfile, getS3Config } from "../../api/apiHandler";
import { showMessage, showErrorMessage, logOutRedirectCall, saveUserSession } from "../common/Utils";
import $, { trim } from 'jquery';
import "parsleyjs/src/parsley.css";
import "parsleyjs";
import 'select2';
import 'select2/dist/css/select2.min.css';
import Swal from 'sweetalert2'
import S3 from 'react-aws-s3';
import { isDisabled } from "@testing-library/user-event/dist/utils";

window.Buffer = window.Buffer || require("buffer").Buffer;

export function Profile() {

    const selectRef = useRef();
    let editFormRef = useRef(null);
    let navigate = useNavigate();
    const auth = localStorage.getItem('token');
    const user_id = localStorage.getItem('user_id');

    // Redirect to login if not logged in
    if (!auth) {
        navigate('/login');
    }

    const [isDisabled, isSetDisabled] = useState(false);
    const [profileUrl, setProfileUrl] = useState(localStorage.getItem('profile_image') ?? process.env.PUBLIC_URL + "/logo.png");
    const [profileImageName, setProfileImageName] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [ adminProfile, setAdminProfile ] = useState({});
    const [ countryList, setCountryList ] = useState([]);
    const [ s3Config, setS3Config ] = useState({});

    useEffect(() => {

        const interval = setInterval(() => {
            if (window.Parsley && window.Parsley.addValidator && !window.Parsley.validators?.notEqual) {
                window.Parsley.addValidator('notEqual', {
                        requirementType: 'string',
                        validateString: function (value, selector) {
                        const oldValue = document.querySelector(selector)?.value;
                        return value !== oldValue;
                    },
                    messages: {
                        en: 'This value should not be the same as the old password.',
                    }
                });
                clearInterval(interval); // Stop once validator is added
            }
            if (window.Parsley && !window.Parsley.validators?.validname) {
                window.Parsley.addValidator('validname', {
                  validateString: function(value) {
                    // Allow only letters (including accented), spaces, and remove emojis/symbols/digits
                    const regex = /^[\p{L} ]+$/u; // \p{L} = any kind of letter
                    return regex.test(value);
                  },
                  messages: {
                    en: "Name must contain only letters and spaces, no digits, symbols, or emojis."
                  }
                });
            }
        }, 1000);
        
        // Initialize Select2 on the select element
        $(selectRef.current).select2();

        // Initialize the parsley plugin
        $(editFormRef.current).parsley();

        async function fetchData() {

            const confResponse = await getS3Config({});
            if (parseInt(confResponse.code) === 1) {
                setS3Config(confResponse.data);
            }

            // Fetch countries to load the page
            const countryReq = {}
            const countryResponse = await getCountryList(countryReq);
            if (parseInt(countryResponse.code) === 1) {
                setCountryList(countryResponse.data);
            }

            // Fetch admin profile for loading
            const profileReq = {
                user_type: 1,
                user_id: user_id
            }
            const profileResponse = await getProfile(profileReq);
            if (parseInt(profileResponse.code) === 1) {
                setAdminProfile(profileResponse.data);
                setProfileUrl(profileResponse.data.profile_image);
            }
        }
        
        fetchData();
    }, []);

    useEffect(() => {
        if (adminProfile) {
            // Set the initial selected value
            $(selectRef.current).val(adminProfile.country_code).trigger('change');
        }
    }, [ profileUrl, adminProfile]);
    
    const handleEditRequest = async(e) => {
        e.preventDefault();
        $(editFormRef.current).parsley().validate({ force: true });
        if ($(editFormRef.current).parsley().isValid()) {

            const editReq = {
                name: trim(editFormRef.current.name.value),
                country_code: editFormRef.current.country_code.value,
                phone: editFormRef.current.phone.value,
                email: editFormRef.current.email.value,
                // profile_image: ''
            }
            if (editFormRef.current.password.value) {
                editReq.password = editFormRef.current.password.value;
            }
            if (profileImageName) {
                editReq.profile_image = profileImageName
            }
            
            const response = await editProfile(editReq);
            if (parseInt(response.code) === 1) {
                if ((adminProfile.email !== editReq.email) || (editReq.password && (editReq.password !== adminProfile.og_password))) {
                    const result = await Swal.fire({
                        title: "",
                        html: `Profile updated successfully<br><br><strong>Note:</strong> You will be logged out of admin panel as you have modified email or password.`,
                        imageUrl: process.env.PUBLIC_URL + '/logo.png',
                        imageSize: '80x80',
                        showConfirmButton: false,
                        showCancelButton: false,
                        timer: 2000,
                        timerProgressBar: true,
                        didClose: () => {
                            logOutRedirectCall();
                        }
                    });
                } else {
                    saveUserSession(response.data);
                    showMessage(response.message);
                    navigate('/dashboard');   
                }
            } else {
                showErrorMessage(response.message);
            }
        } else {
            showErrorMessage("Something went wrong, some required fields are missing!");
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    const togglePassword = () => {
        setShowPassword(prev => !prev);
    };

    const toggleConfirmPassword = () => {
        setShowConfirmPassword(prev => !prev);
    };

    // S3 file upload
    const handleFileInput = async (e) => {
        
        isSetDisabled(true);
        const files = e.target.files[0];
        if (!files) return;

        // Convert to base64 for preview
        const reader = new FileReader();
        reader.onloadend = () => {
            // `reader.result` contains the base64 string
            setProfileUrl(reader.result); // This should be a new useState variable to show preview
        };
        reader.readAsDataURL(files);

        var newfile = new Date().getTime() + files.name

        if (s3Config.REACT_APP_S3_NAME) {
            
            const config = {
                bucketName: s3Config.REACT_APP_S3_NAME,
                dirName: "users",
                region: s3Config.REACT_APP_S3_REGION,
                accessKeyId: s3Config.REACT_APP_S3_ACCESS_KEY,
                secretAccessKey: s3Config.REACT_APP_S3_SECRET_KEY,
                s3Url: s3Config.REACT_APP_S3URL,
            };
            const ReactS3Client = new S3(config);

            ReactS3Client.uploadFile(files, newfile).then(data => {
                if (data.status === 204) {
                    setProfileUrl(`${s3Config.REACT_APP_S3URL}${data.key}`);
                    setProfileImageName(newfile);
                    isSetDisabled(false);
                } else {
                    console.error('Failed to upload profile image');
                    isSetDisabled(false);
                }
            });
        } else {
            showErrorMessage("Something went wrong, please try again later");
        }
    }

    return (
        <>
            <Header />
            <Sidebar />
            <section className="content">
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <h2>Edit Profile</h2>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12">
                            <ul className="breadcrumb float-md-right">
                                <li className="breadcrumb-item">
                                    <a href="/authpanel/dashboard">
                                    <i className="zmdi zmdi-home" />
                                    Dashboard
                                    </a>
                                </li>
                                <li className="breadcrumb-item active">Edit Profile</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <div className="card">
                                <div className="body">
                                    <div className="col-md-8 col-lg-8 col-xl-8 offset-md-2">
                                        <form name="edit_customer" id="edit_customer" ref={editFormRef} onSubmit={handleEditRequest}>
                                            <div className="bg-custom bg-profile  button-color-css">
                                                <div className="text-center preview_holder">
                                                    <img
                                                        id="imagePreview"
                                                        className="rounded-circle img-responsive img-thumbnail"
                                                        src={ profileUrl }
                                                        style={{ minWidth: '150px', minHeight: '150px', maxHeight: '150px', maxWidth: '150px', objectFit: 'contain' }}
                                                    />
                                                </div>
                                                <div className="text-center m-b-10">
                                                    <div className="form-group text-center">
                                                        <div className="">
                                                            <span className="btn btn-primary waves-effect m-b-15 btn-file">
                                                            Change{" "}
                                                                <input 
                                                                    type="file" 
                                                                    id="profile_image"
                                                                    name="profile_image"
                                                                    className="filestyle" 
                                                                    onChange={e => handleFileInput(e)} 
                                                                    data-parsley-trigger="change"
                                                                    accept="image/*" 
                                                                />
                                                            </span>
                                                            <ul className="parsley-errors-list filled">
                                                                <li className="parsley-required" />
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6 col-lg-6 col-xl-6">
                                                    <div className="form-group form-float">
                                                        <div className="form-line focused">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="name"
                                                                id="name"
                                                                defaultValue={adminProfile.name ?? ""}
                                                                data-parsley-trigger="change"
                                                                data-parsley-required-message="Please enter name"
                                                                data-parsley-required="true"
                                                                data-parsley-maxlength="64"
                                                                data-parsley-maxlength-message="Maximum 64 characters allowed in name"
                                                                data-parsley-validname
                                                                data-parsley-validname-message="Name must contain only letters and spaces, no digits, symbols, or emojis"
                                                            />
                                                            <label className="form-label">
                                                                Name <span className="text-danger">*</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-6 col-xl-6">
                                                    <div className="form-group form-float">
                                                        <div className="form-line focused">
                                                            <input
                                                                type="email"
                                                                className="form-control"
                                                                name="email"
                                                                id="email"
                                                                defaultValue={adminProfile.email ?? ""}
                                                                data-parsley-trigger="change"
                                                                data-parsley-required="true"
                                                                data-parsley-type="email"
                                                                data-parsley-required-message="Please enter email address"
                                                                data-parsley-type-message="Please enter valid email address"
                                                            />
                                                            <label className="form-label">
                                                                Email <span className="text-danger">*</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="clearfix" />
                                                <div className="col-md-6 col-lg-6 col-xl-6">
                                                    <div className="form-group form-float">
                                                        <input type="hidden" name="pastpassword" id="pastpassword" value={adminProfile.og_password} />
                                                        <div className="form-line focused">
                                                            <input
                                                                type={showPassword ? "text" : "password"}
                                                                className="form-control"
                                                                name="password"
                                                                id="password"
                                                                data-parsley-trigger="change"
                                                                data-parsley-validate-if-empty
                                                                data-parsley-not-equal="#pastpassword"
                                                                data-parsley-not-equal-message="You new password can not be same as your old password"
                                                                data-parsley-minlength="6"
                                                                data-parsley-minlength-message="Please enter atleast 6 characters"
                                                            />
                                                            <i 
                                                            className={`zmdi ${showPassword ? 'zmdi-eye-off' : 'zmdi-eye'}`}
                                                            onClick={togglePassword}
                                                            style={{
                                                                position: 'absolute',
                                                                right: '15px',
                                                                top: '50%',
                                                                transform: 'translateY(-50%)',
                                                                cursor: 'pointer',
                                                                fontSize: '20px',
                                                                color: '#666'
                                                            }}
                                                            ></i>
                                                            <label className="form-label">Password</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-6 col-xl-6">
                                                    <div className="form-group form-float">
                                                        <div className="form-line focused">
                                                            <input type="password" style={{ display: "none" }} />
                                                            <input
                                                                type={showConfirmPassword ? "text" : "password"}
                                                                className="form-control"
                                                                id="confirmpassword"
                                                                name="confirmpassword"
                                                                data-parsley-validate-if-empty
                                                                data-parsley-trigger="change"
                                                                data-parsley-equalto="#password"
                                                                data-parsley-equalto-message="Your confirm password must match with password"
                                                            />
                                                            <i 
                                                            className={`zmdi ${showPassword ? 'zmdi-eye-off' : 'zmdi-eye'}`}
                                                            onClick={toggleConfirmPassword}
                                                            style={{
                                                                position: 'absolute',
                                                                right: '15px',
                                                                top: '50%',
                                                                transform: 'translateY(-50%)',
                                                                cursor: 'pointer',
                                                                fontSize: '20px',
                                                                color: '#666'
                                                            }}
                                                            ></i>
                                                            <label className="form-label">Confirm Password</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="clearfix" />
                                                <div className="col-md-6 col-lg-6 col-xl-6">
                                                    <div className="form-group">
                                                        <label className="mb-3">Country Code</label>
                                                        <select ref={selectRef}
                                                            defaultValue={adminProfile.country_code}
                                                            className="form-control"
                                                            id="country_code"
                                                            name="country_code"
                                                            // data-parsley-trigger="change"
                                                            data-parsley-required="true"
                                                            data-parsley-required-message="Please select country code"
                                                        >
                                                            <option value="">Choose One</option>
                                                            {
                                                                countryList.length > 0 ? 
                                                                    countryList && countryList.map((item, index) => {
                                                                        return (
                                                                            <option value={item.calling_code}>{item.name} - ({item.calling_code})</option>
                                                                        )
                                                                    }) : ''
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-6 col-xl-6">
                                                    <div className="form-group form-float">
                                                        <label className="form-label text-left" />
                                                        <div className="form-line focused">
                                                            <input
                                                                type="digits"
                                                                className="form-control"
                                                                name="phone"
                                                                id="phone"
                                                                defaultValue={adminProfile.phone ?? ""}
                                                                parsley-trigger="change"
                                                                data-parsley-type="number"
                                                                data-parsley-minlength={8}
                                                                data-parsley-maxlength={12}
                                                                data-parsley-required="true"
                                                                data-parsley-required-message="Please enter phone number"
                                                                data-parsley-minlength-message="Phone number must be 8 digits long"
                                                                data-parsley-maxlength-message="Phone number can't exceed 12 digits"
                                                            />
                                                            <label className="form-label">
                                                                Phone Number <span className="text-danger">*</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="clearfix" />
                                                <div className="col-md-4 col-lg-4 col-xl-4 offset-md-4">
                                                    <div className="form-group">
                                                        <button type="submit" disabled={isDisabled} className="btn btn-raised btn-primary waves-effect m-t-20 mr-3" style={ { color: '#FFFFFF' } }>
                                                            {isDisabled ? "Uploading.." : "Update"}
                                                        </button>
                                                        <a
                                                            href="#"
                                                            onClick={handleGoBack}
                                                            className="btn btn-raised btn-default waves-effect m-t-20"
                                                        >
                                                            Cancel
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}